export const dataHooks = {
  bars: 'stackedBarChart-bars',
  xAxis: 'stackedBarChart-xAxis',
  yAxis: 'stackedBarChart-yAxis',
  tooltip: 'stackedBarChart-tooltip',
};
